module.exports = __webpack_public_path__ + "static/img/rz(3).b79928a4.png";